import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import {
  useGetAddOnStockQuery,
  useAddAddOnStockMutation,
  useUpdateAddOnStockMutation,
  useDeleteAddOnStockMutation,
} from "slices/beautyApp/addOnStockSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import AddStock from "./addStock";

function AddOnStock() {
  const [type, setType] = useState("all");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const auth = useSelector((state) => state.auth?.auth?.user);
  const [del] = useDeleteAddOnStockMutation();
  const [update] = useUpdateAddOnStockMutation();
  const [add] = useAddAddOnStockMutation();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const { data, isLoading, refetch } = useGetAddOnStockQuery({
    page,
    limit,
    search,
  });

  useEffect(() => {
    console.log("API called with params:", { page, limit, search });
  }, [page, limit, search]);

  const col = [
    {
      display: "Image",
      key: "image",
      type: "image",
      style: {
        borderRadius: "50%",
        height: "80px",
        width: "80px",
        objectFit: "cover",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
      },
    },
    { display: "Name", key: "name", type: "display" },
    { display: "Price", key: "price", type: "display" },
    { display: "Total", key: "totalCount", type: "display" },
    { display: "Remaining", key: "remainingCount", type: "display" },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Add on Stock", "view");

  const canDelete = hasActionAccess(
    auth,
    "Beauty App",
    "Add on Stock",
    "delete"
  );

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {/* {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )} */}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this stock?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const onTabClick = (index, item) => {
    if (index === 0) {
      setType("");
    } else {
      setType(item.value);
    }
    refetch();
  };
  const canAdd = hasActionAccess(auth, "Beauty App", "Beautician", "add");

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const handleSubmit = async (data) => {
    try {
      console.log("Submitted data:", data);
      if (editing) {
        await update({ id: data._id, body: data }).unwrap();
        refetch();
      } else {
        const { _id, ...payload } = data;
        await add(payload).unwrap();
        // await add(data).unwrap();
        refetch();
      }

      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddStock
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add New Stock
        </Button>
      )}

      <Tables
        tabs={[]}
        title={"Add on Stocks"}
        handleSearch={handleSearchChange}
        totalPages={data?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        onTabClick={onTabClick}
        currentPage={page}
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default AddOnStock;
